module.exports = __webpack_public_path__ + "img/pay_bottom.1c5b2155.png";